import React, { memo } from 'react';
import { View, TouchableOpacity, Text, StyleSheet, Image } from 'react-native';
import { ThemeColor, Icon, Colors } from '@qnpm/q-theme';
import { commonUtil, performanceUtil, qAccessibilityLabel, logEvent, QavEvent } from '@qnpm/q-design-utils';
const MonthHeader = (props) => {
    const { title, style, config, computedStyle, onOpenURL, onOpenURLCallback, accessibilityPreName, mode } = props;
    const { title: configTitle, titleColor, subTitle, subTitleColor, operationConfig, backgroundColor, operationImage } = config || {};
    const { imageUri, text, color, scheme } = operationConfig || {};
    // 展示的标题，以配置的为主
    const showTitle = configTitle || title;
    // 没有标题时，不展示
    if (!title) {
        return null;
    }
    return (<View style={[
        computedStyle.monthHeader.wrapper,
        style,
        {
            backgroundColor: backgroundColor || Colors.palette.silver.shade10
        }
    ]}>
            <View {...qAccessibilityLabel(`${accessibilityPreName}MonthHeaderContainer#${title}`)} style={styles.wrapper}>
                <View style={styles.titleContainer}>
                    <Text {...qAccessibilityLabel(`${accessibilityPreName}MonthHeaderTitle#${title}`)} style={[
        styles.title,
        computedStyle.monthHeader.title,
        titleColor ? { color: titleColor } : null
    ]}>
                        {showTitle}
                    </Text>
                    {subTitle ? (<>
                            <View style={[
        styles.line,
        computedStyle.monthHeader.line,
        subTitleColor
            ? { backgroundColor: subTitleColor }
            : null
    ]}/>
                            <Text {...qAccessibilityLabel(`${accessibilityPreName}MonthHeaderSubTitle#${subTitle}`)} style={[
        styles.subTitle,
        computedStyle.monthHeader.subTitle,
        subTitleColor
            ? { color: subTitleColor }
            : null
    ]}>
                                {subTitle}
                            </Text>
                        </>) : null}
                </View>
                <TouchableOpacity {...qAccessibilityLabel(`${accessibilityPreName}MonthHeaderButton#${title}`)} activeOpacity={1} style={styles.operationContainer} onPress={() => {
        if (scheme) {
            onOpenURL && onOpenURL(scheme);
            commonUtil.openURL(scheme, {
                callback: onOpenURLCallback,
                type: 'navibar-none'
            });
            logEvent(new QavEvent({
                page: accessibilityPreName,
                model: 'month_header',
                action: 'click_month_header_link',
                attributes: {
                    url: scheme,
                    mode,
                    title,
                    text,
                    operTime: Date.now()
                }
            }));
        }
    }}>
                    {imageUri ? (<Image source={{ uri: imageUri }} style={computedStyle.monthHeader.oprImage}/>) : null}
                    {text ? (<View style={styles.operationContainer}>
                            <Text style={[
        styles.oprText,
        computedStyle.monthHeader.oprText,
        color ? { color } : null
    ]}>
                                {text}
                            </Text>
                            {scheme ? (<Icon name="chevronForward" size={14} color={color || ThemeColor.brandText} style={computedStyle.monthHeader.oprArrow}/>) : null}
                        </View>) : null}
                    {operationImage ? (<Image {...qAccessibilityLabel(`${accessibilityPreName}MonthHeaderBgImage#${title}`)} source={{ uri: operationImage }} style={[
        styles.oprBgImage,
        computedStyle.monthHeader.oprBgImage
    ]}/>) : null}
                </TouchableOpacity>
            </View>
        </View>);
};
export default memo(MonthHeader, performanceUtil.fastDeepEqual);
const styles = StyleSheet.create({
    wrapper: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: 'transparent'
    },
    titleContainer: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    title: {
        color: ThemeColor.text1,
        fontWeight: 'bold'
    },
    subTitle: {
        color: ThemeColor.text1,
        fontWeight: 'bold'
    },
    line: {
        backgroundColor: ThemeColor.text1,
        alignSelf: 'center'
    },
    operationContainer: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    oprTextContainer: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    oprText: {
        color: ThemeColor.brandText
    },
    oprBgImage: {
        position: 'absolute',
        width: '100%',
        right: 0,
        zIndex: -1
    }
});
